module.exports = __webpack_public_path__ + "img/1985474 1 (Traced).2d60fd83.svg";